import { Users, Building2, Handshake, ListTodo, GitBranch, Bell, StickyNote } from "lucide-react";

export function notifTimeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} minute${Math.floor(s / 60) === 1 ? "" : "s"} ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} hour${Math.floor(s / 3600) === 1 ? "" : "s"} ago`;
  if (s < 172800) return "Yesterday";
  if (s < 604800) return `${Math.floor(s / 86400)} days ago`;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function notifRecordPath(n) {
  if (n.task_id) return `/tasks/${n.task_id}`;
  if (n.note_id) return `/notes?highlight=${n.note_id}`;
  if (n.lead_id) return `/leads/${n.lead_id}`;
  if (n.asset_id) return `/assets/${n.asset_id}`;
  if (n.broker_id) return `/brokers/${n.broker_id}`;
  if (n.match_id) return "/kanban";
  return null;
}

// Task-status chip tonal styling (reuses the CRM's existing badge tones).
export function taskStatusChip(status) {
  switch (status) {
    case "Completed": return { label: "Done", cls: "border-emerald-100 bg-emerald-50 text-emerald-700" };
    case "Cancelled": return { label: "Cancelled", cls: "border-slate-200 bg-slate-50 text-slate-500" };
    case "In Progress": return { label: "In Progress", cls: "border-amber-100 bg-amber-50 text-amber-700" };
    default: return { label: "Open", cls: "border-amber-100 bg-amber-50 text-amber-700" };
  }
}

// Icon component + tint per record_type.
export function notifIconMeta(recordType) {
  switch (recordType) {
    case "Lead": return { Icon: Users, tint: "text-indigo-500 bg-indigo-50" };
    case "Asset": return { Icon: Building2, tint: "text-emerald-600 bg-emerald-50" };
    case "Broker": return { Icon: Handshake, tint: "text-amber-600 bg-amber-50" };
    case "Task": return { Icon: ListTodo, tint: "text-sky-600 bg-sky-50" };
    case "Match": return { Icon: GitBranch, tint: "text-purple-600 bg-purple-50" };
    case "Note": return { Icon: StickyNote, tint: "text-rose-600 bg-rose-50" };
    default: return { Icon: Bell, tint: "text-slate-500 bg-slate-100" };
  }
}
